import React, { ChangeEvent } from "react";
import {
    Table, Input, Row, Col, Pagination, Button, Spin, notification, Form, 
    FormInstance, Modal, Popconfirm, Select, TreeSelect, Badge, Breadcrumb, 
    Dropdown, Menu, Space, InputNumber, Empty,Switch,
    Steps,
    Alert,
    Typography,
} from "antd";
import {
    BasicStateForListModel
} from "../models";
import { Link, NavLink, RouteComponentProps } from "react-router-dom";
import { RootStoreModel } from "../../redux/reducers";
import { connect } from "react-redux";
import { PlusOutlined, InfoCircleOutlined, CheckCircleFilled, StopFilled, CopyOutlined } from '@ant-design/icons';
import { gaEvent } from "../../withTracker"
import { getFeishuList, addOrUpdateFeishu, deleteFeishu,syncFeishuUsers } from "../../axios/api.account"

import { Translation } from "react-i18next";
import { stat } from "fs";
import { error } from "console";

interface stateModel extends BasicStateForListModel {
    name: string,
    showAddForm: boolean,
    isUpdate: boolean,
    feishuId: string,
    search: string,
    step: number,
    isSubmit: boolean,
    step1Obj: any,
    step2Obj: any,
    step3Obj: any,
    sso: boolean
}
interface propsModel extends RouteComponentProps<any, any, any> {}

const { Column } = Table;
const { Item } = Form;
const mapStatetoProps = (state: RootStoreModel) => ({});
const callbackUrl = `${process.env.REACT_APP_API_URL}/feishu/callback`

const columns = [
  {
      title: '权限类别',
      dataIndex: 'category',
      key: 'category',
      width: '20%',
      onCell: (record:any) => ({
        rowSpan: record.category ? 8 : 0,
      }),
    },
    {
      title: '权限名称',
      dataIndex: 'function',
      key: 'function',
      width: '55%',
    },
    {
      title: '权限范围',
      dataIndex: 'scope',
      key: 'scope',
      width: '15%',
    },
];

const tData = [
    { key: '1', category: '通讯录管理', function: '获取通讯录基本信息',scope: '全部人员' },
    { key: '2', category: '', function: '获取部门基础信息',scope: '全部人员' },
    { key: '3', category: '', function: '获取通讯录部门组织架构信息',scope: '全部人员' },
    { key: '4', category: '', function: '获取用户基本信息',scope: '全部人员' },
    { key: '5', category: '', function: '获取用户组织架构信息',scope: '全部人员' },
    { key: '6', category: '', function: '获取用户邮箱信息',scope: '全部人员' },
    { key: '7', category: '', function: '获取用户 user ID',scope: '全部人员' },
    { key: '8', category: '', function: '获取个人邮箱信息',scope: '全部人员' },
];

class FeishuIndex extends React.Component<propsModel, stateModel> {
    formRef = React.createRef<FormInstance>();
    formStepRef = React.createRef<FormInstance>();
    formThreeStepRef = React.createRef<FormInstance>();
    constructor(props: propsModel) {
        super(props);
        this.state = {
            name: "FeishuIndex",
            showAddForm: false,
            isUpdate: false,
            pageIndex: 1,
            pageSize: 20,
            totalCount: 0,
            loading: false,
            data: [],
            columns: [],
            feishuId: "",
            search: "",
            step: 0,
            isSubmit: false,
            step1Obj: {},
            step2Obj: {},
            step3Obj: {syncEnabled: false, ssoEnabled: true},
            sso: true
        }
        this.Init();
    }

    Init() {
        this.getList();
    }

    getList(
        pageIndex = this.state.pageIndex, 
        pageSize = this.state.pageSize
    ) {
        var params = { search: this.state.search, pageIndex, pageSize }
        getFeishuList(params).then(
            (res) => {
                this.setState({
                    data: res.dataList,
                    pageIndex: res.pageIndex,
                    pageSize: res.pageSize,
                    totalCount: res.totalCount,
                    loading: false
                })
                // if (!res.dataList.length) {
                //     notification.warning({ message: <Translation>{t => {return t("查询数据为空")}}</Translation> })
                // }
            },
            error => {
                console.log(error);                
                notification.error({ message: <Translation>{t => {return t("查询失败")}}</Translation> })
                this.setState({ loading: false })
            }
        )
    }

    handleCopy = () => {
        if (navigator.clipboard) {
            try {
                navigator.clipboard.writeText(callbackUrl);
                notification.success({ message: <Translation>{t => {return t("已复制到剪贴板")}}</Translation> });
            } catch (err) {
                this.handleCopyFallback(); // 降级
            }
        } else {
            this.handleCopyFallback(); // 降级
        }
    };

    handleCopyFallback = () => {
        const textarea = document.createElement('textarea');
        textarea.value = callbackUrl;
        textarea.style.position = 'fixed'; // 防止滚动
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        try {
            const successful = document.execCommand('copy');
            if(successful)
                notification.success({ message: <Translation>{t => {return  t("已复制到剪贴板")}}</Translation> })
            else
                notification.error({ message: <Translation>{t => {return t("复制失败，请手动复制")}}</Translation> })
        } catch (err) {
            notification.error({ message: <Translation>{t => {return t("复制失败，请手动复制")}}</Translation> });
        }

        document.body.removeChild(textarea);
    };


    onSearch() {   
        this.setState({ loading: true })     
        this.getList(1);
    }
    
    formOK = () => {
        this.formThreeStepRef.current?.validateFields().then(
            (res) => { 
                this.setState({loading: true });
                const params = {
                    id: this.state.feishuId,
                    appId: this.state.step1Obj.appId,
                    appSecret: this.state.step1Obj.appSecret,
                    syncEnabled: res.syncEnabled,
                    ssoEnabled: res.ssoEnabled
                }
                this.putFeishu(params)
            },
            error => {
                console.log(error);
            }
        )
    }

    formCancel = () => {
        this.setState({ 
            showAddForm: false, 
            loading: false,
            step: 0,
            isSubmit: false
        })
    }

    openModal = () => {
        var obj1 = {};
        var obj2 = {};
        var obj3 = {syncEnabled: false, ssoEnabled: true};

        this.setState({ 
            showAddForm: true, 
            isUpdate: false,
            step1Obj: obj1,
            step2Obj: obj2,
            step3Obj: obj3,
            step: 0,
            feishuId: ""
        });
        this.formRef?.current?.setFieldsValue({
            appId: "",
            appSecret: ""
        });
    };

    updateFeishu = (row: any) => {       
        var obj1 = {
            appId: row.appId,
            appSecret: row.appSecret
        };
        var obj3 = {
            syncEnabled: row.syncEnabled,
            ssoEnabled: row.ssoEnabled
        };
        this.formRef.current?.setFieldsValue(obj1);

        this.setState({ 
            showAddForm: true, 
            isUpdate: true, 
            feishuId: row.id,
            step: 0,
            step1Obj: obj1,
            step3Obj: obj3,
            sso: row.ssoEnabled
        })
    }

    syncFeishu = (row: any) => {
        this.setState({loading: true});
        syncFeishuUsers(row.id).then(
            ()=>{
                this.getList(1);
                notification.success({ message: <Translation>{t => {return t("同步成功")}}</Translation> });
                this.setState({loading: false});
            },
            error => {
                this.setState({loading: false});
            }
        );
    }

    putFeishu(params: any) {
        console.log(params);
        addOrUpdateFeishu(params).then(
            () => {
                // this.getList();
                this.formRef.current?.resetFields();
                this.formStepRef.current?.resetFields();
                this.formThreeStepRef.current?.resetFields();
                this.setState({ 
                    showAddForm: false, 
                    loading: false,
                    feishuId: ""
                })
                this.getList(1);
                if (this.state.isUpdate) {
                    notification.success({ message: <Translation>{t => {return t("修改成功")}}</Translation> });
                } 
                else {
                    notification.success({ message: <Translation>{t => {return t("添加成功")}}</Translation> });
                }
            }, 
            error => {
                console.log(error);
                this.setState({ loading: false });
                if (this.state.isUpdate) {
                    notification.error({ message: <Translation>{t => {return t("修改失败")}}</Translation> });
                } 
                else {
                    notification.error({ message: <Translation>{t => {return t("添加失败")}}</Translation> });
                }
            }
        )
    }

    componentDidMount() {
    }

    deleteFeishu = (id: string) => {
        deleteFeishu(id).then(
            () => {
                notification.success({ message: <Translation>{t => {return t("删除成功")}}</Translation> });
                this.getList();
            },
            () => {
                notification.error({ message: <Translation>{t => {return t("删除失败")}}</Translation> });
            }
        )
    }

    oneStep(){
      this.formRef?.current?.validateFields().then(res=>{
        this.setState({step: this.state.step + 1, step1Obj: res });
      })
    }

    twoStep(){
        this.formStepRef?.current?.validateFields().then(res=>{
            this.setState({step: this.state.step + 1, step2Obj: res });
        })
    }

    prevStep() {
        console.log(this.state.step,this.state.step1Obj);
        if(this.state.step == 1)
        {
            this.formRef?.current?.setFieldsValue(this.state.step1Obj);
        }
        else if(this.state.step == 2)
        {
            this.formStepRef?.current?.setFieldsValue(this.state.step2Obj);
        }
        this.setState({step: this.state.step - 1 });
    }

    render() {
        const { 
            data, 
            showAddForm, 
            isUpdate, 
            loading,
            pageIndex, 
            pageSize, 
            totalCount,
            step,
            isSubmit,
            step1Obj,
            step2Obj,
            step3Obj,
            sso
        } = this.state;
        
        return (
            <Translation>{t => {
                return (
                    <>
                        <div>
                            <h5 className="breadcrumbTop py-2">
                                <Breadcrumb>
                                    <Breadcrumb.Item>{t("系统集成")}</Breadcrumb.Item>
                                    <Breadcrumb.Item>{t("飞书")}</Breadcrumb.Item>
                                </Breadcrumb>
                                <Row style={{padding: "32px 0 11px 0"}}>
                                    <Space>
                                        <img style={{width:30}} src="/images/openapi.png" alt="" />
                                        <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("飞书")}</span>
                                    </Space>
                                </Row>
                            </h5>
                            <Row style={{ width: "100%" }}>
                                {/* <div className="borderBox">
                                    <Row className="mb-3">
                                        <Col span={8}>
                                            <Form.Item label={t("配置名称")}  name="name">
                                                <Input  placeholder={t("输入配置名称")} onChange={(e) => {this.setState({search: e.target.value})}}></Input>
                                            </Form.Item>
                                        </Col>
                                        <Col offset={1}>
                                            <Form.Item>
                                                <Button type="primary" onClick={
                                                    () => { 
                                                        this.onSearch();
                                                    }
                                                }>{t("查询")}
                                                </Button>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div> */}
                                <div className="borderBox">
                                    <Row style={{ width: "100%", marginBottom: 8 }}>
                                        <Col className="ms-auto">
                                            <Button type="primary" onClick={
                                                () => {
                                                    this.openModal();
                                                }
                                            }><PlusOutlined />{t("添加配置")}
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Table 
                                        size="middle" 
                                        loading={loading}
                                        dataSource={data} 
                                        style={{width: "100%"}} 
                                        pagination={false}
                                        locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                                    >
                                        <Column
                                            key="key"
                                            dataIndex="key"
                                            title={t("序号")}
                                            render={(v, d, i) => i + 1}
                                        ></Column>
                                        <Column
                                            title={t("App ID")}
                                            key="appId"
                                            dataIndex="appId"
                                        ></Column>
                                        <Column
                                            title={t("App Secret")}
                                            key="appSecret"
                                            dataIndex="appSecret"
                                        ></Column>
                                        <Column 
                                            title={t("最近同步时间")} 
                                            key="lastSyncTime" 
                                            dataIndex="lastSyncTime"
                                        ></Column>
                                        <Column key="syncEnabled" dataIndex="syncEnabled" title={t("用户和组织同步")}
                                            render={(v) => (
                                            <> 
                                                {v &&(
                                                    <span ><CheckCircleFilled  style={{color:"#4CB8BE",fontSize:16}}/>&nbsp;&nbsp;{t("开启")}</span>
                                                )}
                                                {!v &&(
                                                    <span><StopFilled  style={{color:"#C9A063",fontSize:16}}/>&nbsp;&nbsp;{t("关闭")}</span>
                                                )}
                                            </>
                                            )}
                                        ></Column>                                        
                                        <Column key="ssoEnabled" dataIndex="ssoEnabled" title={t("单点登录")}
                                            render={(v) => (
                                            <> 
                                                {v &&(
                                                    <span ><CheckCircleFilled  style={{color:"#4CB8BE",fontSize:16}}/>&nbsp;&nbsp; {t("开启")}</span>
                                                )}
                                                {!v &&(
                                                    <span><StopFilled  style={{color:"#C9A063",fontSize:16}}/>&nbsp;&nbsp;{t("关闭")}</span>
                                                )}
                                            </>
                                            )}
                                        ></Column>
                                        <Column
                                            title={t("操作")}
                                            key="id"
                                            dataIndex="id"
                                            render={(v, row: any, index) => {                                        
                                                return (
                                                    <Space size={8}>
                                                        <Button type="link" block onClick={
                                                            () => {
                                                                this.syncFeishu(row);
                                                            }
                                                        }>{t("同步")}
                                                        </Button>
                                                        <Button type="link" block onClick={
                                                            () => {
                                                                this.updateFeishu(row);
                                                            }
                                                        }>{t("编辑")}
                                                        </Button>
                                                        <Popconfirm
                                                            title={`${t("确认删除")}？`}
                                                            onConfirm={() => {
                                                                this.deleteFeishu(row.id);
                                                            }}
                                                            okText={t("确认")}
                                                            cancelText={t("取消")}
                                                        >
                                                            <Button type="link" block>{t("删除")}</Button>
                                                        </Popconfirm>
                                                    </Space>
                                                )
                                            }}></Column>
                                    </Table>
                                    <Pagination
                                        style={{ textAlign: "right", marginTop: "20px" }}
                                        pageSize={ pageSize }
                                        current={ pageIndex }
                                        total={ totalCount }
                                        showTotal={ (total, range) => `${range[0]}-${range[1]} / ${total} ${t("条")}` }
                                        onChange={ (page, pageSize) => this.getList(page, pageSize) }
                                        onShowSizeChange={ (current, size) => this.getList(current, size) }
                                    ></Pagination>
                                </div>
                            </Row>
                        </div>
                        <Modal
                            confirmLoading={loading}
                            maskClosable={false}
                            open={showAddForm}
                            destroyOnClose={true}
                            title={this.state.isUpdate ? t("修改配置") : t("添加配置")}
                            forceRender={true}
                            width={"900px"}
                            footer={null}
                            // onOk={() => this.formOK()}
                            onCancel={() => this.formCancel()}
                            // okText={t("确认")}
                            // cancelText={t("取消")}
                        >
                            <Steps
                                current={step}
                                className="mt-4"
                                style={{width:'90%'}}
                                items={[
                                    {
                                    title: t('配置组织内部应用')
                                    },
                                    {
                                    title: t('配置应用权限')
                                    },
                                    {
                                    title: t('开启服务')
                                    },
                                ]}
                                />
                                <div className="mx-auto" style={{ marginTop: "50px",width:'90%' }}>
                                <div style={{ }}>
                                    {step === 0 && (
                                    <Form
                                        ref={this.formRef}
                                        name="basic"
                                        layout="vertical"
                                        labelCol={{ span: 4 }}
                                        wrapperCol={{ span: 16 }}
                                        //style={{ maxWidth: 600 }}
                                        autoComplete="off"
                                        initialValues={step1Obj}
                                    >
                                        <p>
                                            1. 进入<a target="_blank" href="https://open.feishu.cn/app">飞书开放平台</a>创建组织自建应用。<a target="_blank" href="https://open.feishu.cn/document/develop-process/self-built-application-development-process">参考如何创建组织内部应用</a>
                                        </p>
                                        <p>
                                            2. 创建应用后，在凭证与基础信息-综合信息完善应用图标。
                                        </p>
                                        <p>
                                            3. 将应用凭证中 App ID、App Secret 复制粘贴到以下输入框。
                                        </p>
                                        <Form.Item
                                            label={t("App ID")}
                                            name="appId"
                                            rules={[{ required: true, message: t('请输入 App ID') }]}
                                        >
                                            <Input placeholder={"请输入 App ID"} autoComplete="off" />
                                        </Form.Item>
                                        <Form.Item
                                            label={t("App Secret")}
                                            name="appSecret"
                                            rules={[
                                                { 
                                                    required: true,
                                                    message: t('请输入 App Secret')
                                                }
                                            ]}
                                        >
                                            <Input placeholder={"请输入 App Secret"} autoComplete="off" />
                                        </Form.Item>
                                        <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
                                            <Button type="primary" onClick={() => { this.oneStep(); } } style={{width:"30%"}} htmlType="submit">
                                                {t("下一步")}
                                            </Button>
                                            <Button type="primary"  onClick={() => { this.formCancel() }} style={{width:"30%", marginLeft:"40px"}} htmlType="submit">
                                                {t("取消")}
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                    )}
                                    {step === 1 && (
                                    <Form
                                        ref={this.formStepRef}
                                        name="basic"
                                        labelCol={{ span: 4 }}
                                        wrapperCol={{ span: 16 }}
                                        //style={{ maxWidth: 600 }}
                                        autoComplete="off"
                                    >
                                        <p >
                                            <Alert
                                                message="请完成以下权限配置，如配置不完整，后续开启的服务将可能无法使用。"
                                                type="warning"
                                                showIcon
                                                style={{ marginBottom: 12 }}
                                            />
                                        </p>
                                        <p>
                                            进入<a target="_blank" href="https://open.feishu.cn/app">飞书开放平台</a>在步骤一已创建的组织应用详情-权限管理中配置以下权限：
                                        </p>
                                        <div>
                                            <Table
                                                size="small"
                                                columns={columns}
                                                dataSource={tData}
                                                pagination={false}
                                                bordered
                                            />
                                        </div>
                                        <Form.Item style={{marginTop:"30px"}} wrapperCol={{ offset: 4, span: 16 }}>
                                            <Button type="primary" disabled={isSubmit} onClick={ () => { this.twoStep(); } } style={{width:"30%"}} htmlType="submit">
                                                {t("下一步")}
                                            </Button>
                                            <Button type="primary"  onClick={() => { this.prevStep(); }} style={{width:"30%", marginLeft:"40px"}}>
                                                {t("上一步")}
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                    )}
                                    {step === 2 &&(
                                        <Form
                                            ref={this.formThreeStepRef}
                                            name="basic"
                                            layout="vertical"
                                            //style={{ maxWidth: 600 }}
                                            autoComplete="off"
                                            initialValues={step3Obj}
                                        >
                                            <Form.Item
                                                label={
                                                    <span>
                                                        <strong style={{ fontSize: '16px', marginRight: '8px' }}>
                                                        用户和组织同步
                                                        </strong>
                                                        <span style={{ fontSize: '14px', color: '#666' }}>
                                                        开启后，可保持飞书通讯录的定时同步。
                                                        建议确认飞书应用可见权限范围。
                                                        </span>
                                                    </span>
                                                }
                                                valuePropName="checked"
                                                name="syncEnabled"
                                            >
                                                <Switch />
                                            </Form.Item>
                                            <Form.Item
                                                label={
                                                    <span>
                                                        <strong style={{ fontSize: '16px', marginRight: '8px' }}>
                                                        单点登录
                                                        </strong>
                                                        <span style={{ fontSize: '14px', color: '#666' }}>
                                                        开启后，即可快速跳转飞书登录页面进行验证。
                                                        </span>
                                                    </span>
                                                }
                                                name="ssoEnabled"
                                                valuePropName="checked"
                                            >
                                                <Switch onChange={(checked) => {this.setState({sso:checked })}}/>
                                            </Form.Item>
                                            {sso && <>
                                                <div style={{ marginBottom: 24 }}>
                                                    <Typography.Paragraph>
                                                        需要配置登录信息: 复制以下信息，粘贴到
                                                        <a target="_blank" href="https://open.feishu.cn/app">飞书开放平台</a>
                                                        应用详情-安全设置-重定向 URL 的输入框中。
                                                    </Typography.Paragraph>
                                                </div>
                                                
                                                <div style={{ marginBottom: 16 }}>
                                                    <Typography.Text strong>回调请求地址</Typography.Text>
                                                </div>
                                                
                                                <Space.Compact style={{ width: '100%', marginBottom: 24 }}>
                                                <Input
                                                    value={callbackUrl}
                                                    readOnly
                                                    style={{
                                                    backgroundColor: '#fafafa',
                                                    border: '1px solid #d9d9d9',
                                                    padding: '8px 12px',
                                                    }}
                                                />
                                                <Button 
                                                    type="primary" 
                                                    icon={<CopyOutlined />}
                                                    onClick={this.handleCopy}
                                                    style={{
                                                    height: 'auto',
                                                    padding: '8px 16px',
                                                    }}
                                                >
                                                    复制
                                                </Button>
                                                </Space.Compact>
                                            </>}
                                            <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
                                                <Button type="primary" disabled={isSubmit} onClick={()=> isSubmit ? undefined : this.formOK() } style={{width:"30%"}} htmlType="submit">
                                                    {t("保存配置")}
                                                </Button>
                                                <Button type="primary"  onClick={() => { this.prevStep(); }} style={{width:"30%", marginLeft:"40px"}} htmlType="submit">
                                                    {t("上一步")}
                                                </Button>
                                            </Form.Item>
                                        </Form>
                                    )}
                                </div>
                            </div>
                        </Modal>
                    </>
                )
            }}</Translation>
        )
    }
}

export default connect(mapStatetoProps, {})(FeishuIndex);